import { AnimatePresence as _AnimatePresence } from "motion/react";
import React, { ComponentProps, useEffect, useRef } from "react";

type AnimatePresenceProps = ComponentProps<typeof _AnimatePresence>;

export const AnimatePresence = ({
  children,
  ...props
}: AnimatePresenceProps) => {
  const initialRender = useRef(true);

  useEffect(() => {
    initialRender.current = false;
  }, []);

  // useRef is intentional here — motion reads `custom` at animation time (during exit),
  // not at React render time, so a re-render trigger via useState is unnecessary.
  return (
    <_AnimatePresence custom={initialRender.current} {...props}>
      {children}
    </_AnimatePresence>
  );
};
